// Maps the current panel route to an image_profiles scope (products/articles/sliders/banners).
export function imageScopeFor(route, explicit) {
  if (explicit) return explicit;
  const p = String((route && (route.path || route.fullPath)) || (typeof window !== 'undefined' ? window.location.pathname + window.location.hash : '')).toLowerCase();
  if (/news|blog|article/.test(p)) return 'articles';
  if (/slider/.test(p)) return 'sliders';
  if (/banner|homepage|display|template_settings|menus/.test(p)) return 'banners';
  if (/product|brand|categor/.test(p)) return 'products';
  return '';
}